import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import SignInDataService from '../../../../services/SignInDataService';
import SignUpDataService from '../../../../services/SignUpDataService';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { setIsUserAuthenticated } from '../../authentication/AuthenticationSlice';
import { PAGE_STATE } from '../../constants/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { PRE_LOGIN_LOADING_STATES } from '../constants';

import { resetAcceptInvitationFormFields, setIsAcceptInvitationSuccess, setValidResetToken, updateAcceptInvitationFormFields } from './MemberAcceptInvitationSlice';
import { componentKey, setLoadingState,  } from './MemberAcceptInvitationSlice';

export const { validateToken, submitAcceptInvitationRequest } = {
    validateToken: (payload) => {
        return {
            type: "ACCEPT_INVITATION/VALIDATE_TOKEN",
            payload: payload
        }
    },
    submitAcceptInvitationRequest: (payload) => {
        return {
            type: "ACCEPT_INVITATION/SUBMIT_ACCEPT_INVITATION_REQUEST",
            payload: payload
        }
    },
}

function* validateTokenAsync(action){
    try {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.MEMBER_LOGIN_PAGE_LOADING }));
        const response = yield SignInDataService.validateResetToken(action.payload);
        if(response?.data){
            if(response?.data?.Status){
                yield put(setValidResetToken(true));
                yield put(updateAcceptInvitationFormFields({Email: action.payload.Email, Token: action.payload.Token, GRecaptchaResponse: action.payload.GRecaptchaResponse}))
            }else{
                yield put(addNotifications({
                    heading: "Error",
                    message: "You have accessed an invalid url",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    }catch {
        yield put(addNotifications({
            heading: "Error",
            message: "Invalid request. Please try again.",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.MEMBER_LOGIN_PAGE_READY }));
    }
}

function* submitAcceptInvitationRequestAsync(action) {
    try {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.MEMBER_LOGIN_PAGE_LOADING }));
        const response = yield SignUpDataService.submitAcceptInvitationRequest(action.payload);
        if(response?.data){
            if(response?.data?.Status){
                yield put(addNotifications({
                    heading: "Success",
                    message: "Invitation accepted successfully",
                    variant: TOASTER_VARIANT.SUCCESS
                }));
                yield put(setIsUserAuthenticated(true));
                yield put(setIsAcceptInvitationSuccess(true));
                yield put(setValidResetToken(false));
                yield put(resetAcceptInvitationFormFields());
            }else{
                yield put(addNotifications({
                    heading: "Error",
                    message: "You have accessed an invalid url",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    }catch {
        yield put(addNotifications({
            heading: "Error",
            message: "Invalid request. Please try again.",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.MEMBER_LOGIN_PAGE_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(validateToken().type, validateTokenAsync),
        takeLatest(submitAcceptInvitationRequest().type, submitAcceptInvitationRequestAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);